import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/**
 * Converts `\n` characters into `<br />` tags and returns the result as
 * SafeHtml for direct `[innerHTML]` binding — lets the landing copy
 * keep authored line breaks + inline emphasis (`<strong>`, `<em>`,
 * accent `<span>`) without escaping.
 */
export function sanitizeHtmlWithLineBreaks(sanitizer: DomSanitizer, content: string): SafeHtml {
  const normalized = content ?? '';
  const withLineBreaks = normalized.replace(/\n/g, '<br />');
  return sanitizer.bypassSecurityTrustHtml(withLineBreaks);
}
